module.exports = __webpack_public_path__ + "img/169_thumbnail.f08c6fe7.jpg";